/**
 * ScrollToTop 컴포넌트
 * 페이지 이동 시 스크롤을 맨 위로 이동시킵니다.
 * React Router의 useLocation 훅을 사용하여 경로 및 쿼리 파라미터 변경을 감지합니다.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // 페이지 경로 또는 쿼리 파라미터가 변경될 때마다 스크롤을 맨 위로 이동
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}

export default ScrollToTop;
